import {useEffect, useState} from 'react'
import {useEventListener} from '@eitje/hooks'

export const useFitInViewportCheck = ({element, offset = 0}) => {
	const [doesItFit, setDoesItFit] = useState({vertical: true, horizontal: true})

	const checkFit = () => {
		if (!element?.current) return

		const {height, width} = element.current.getBoundingClientRect()

		const vertical = window.innerHeight > height + offset
		const horizontal = window.innerWidth > width + offset

		setDoesItFit({vertical, horizontal})
	}

	useEffect(() => {
		checkFit()
	}, [element, offset])

	useEventListener('resize', () => {
		// Debounce or throttle if needed
		checkFit()
	})

	return doesItFit
}
